<template>
  <div class="row">
    <div class="col-12 d-flex justify-content-center align-items-center row-controls order-lg-1 order-2">
      <div v-if="!loading" class="col-2 col-mobile">
        <span class="title" style="margin-left:30px">{{ sessionLabel }}</span>
      </div>
      <div v-if="!loading" class="col-8 slide-controls">
        <div class="d-flex justify-content-center align-items-center">
          <div class="col-4 text-center">
            <font-awesome-icon :icon="['fas', 'fa-minus']" size="md"
              class="cursor-pointer color-icon" @click="minusPlay()" @mouseover="hover = true" @mouseleave="hover = false"/>
          </div>
          <div class="col-4 text-center">
            <font-awesome-icon v-if="!slidePlay" :icon="['fas', 'fa-play']" size="md" 
              class="cursor-pointer color-icon" @click="startPlay()" @mouseover="hover = true" @mouseleave="hover = false"/>
            <font-awesome-icon v-else :icon="['fas', 'fa-pause']" size="md"
              class="cursor-pointer color-icon" @click="stopPlay()" @mouseover="hover = true" @mouseleave="hover = false"/>
          </div>
          <div class="col-4 text-center">
            <font-awesome-icon :icon="['fas', 'fa-plus']" size="md"
              class="cursor-pointer color-icon" @click="plusPlay()" @mouseover="hover = true" @mouseleave="hover = false" />
          </div>
          <span class="color-icon size-seconds position-absolute" :style="!hover ? { display: 'none'} : {display: 'block', right: '-35px' , top: '-2px'}">{{ seconds }}s</span>            
        </div>
      </div>
      <div v-if="!loading" class="col-2 x-of-y col-mobile">
        <span class="title" style="margin-left:65px">{{ imageNumber }} / {{ totalSection }} </span>
      </div>
    </div>
    <div class="col-12 order-lg-2 order-1">
      <Carousel ref="crslModel" :transition="1" v-bind="settings" v-model="currentSlideImg" @click="click" id="modelo" @slide-end="moveSlide">
        <Slide v-if="loading">
          <div class="text-center mt-5 spin-load">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </Slide>
        <Slide v-else v-for="(img, i) in imagesModel" :key="i">
          <div class="card">
            <img :src="`${img}`" :alt="`${nameModel}-${i}`" @dblclick="this.$emit('showModalModelSlideShow', true)" width="467" height="700"/>
          </div>
        </Slide>

        <template #addons>
          <Navigation v-if="!loading"/>
        </template>
      </Carousel>
    </div>
  </div>  
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Carousel, Navigation, Slide } from 'vue3-carousel'
import { userStore } from 'stores/user'
import { mapState } from 'pinia'
import { localeStore } from 'stores/locale'
import { event } from 'vue-gtag'
import 'vue3-carousel/dist/carousel.css'

export default defineComponent({
  name: 'CarroselModel',
  components: {
    Carousel,
    Slide,
    Navigation
  },
  props: ['imagesModel', 'nameModel', 'currentImage', 'slidePlay', 'seconds', 'sessionLabel', 'keyDownEvents'],
  emits: ['showModalSubscribePlans', 'changeAutomatic', 'updateSlidePlay', 'updateCurrentImage', 'updateSeconds', 'showModalModelSlideShow', 'updateImageView'],
  computed: {
    ...mapState(userStore, ['isActiveUser']),
    ...mapState(localeStore, ['locale']),
  },
  created() {
    if (this.imagesModel.length)
      this.loading = false
      this.imageNumber = 1
      this.totalSection = this.imagesModel.length
      window.addEventListener('keydown', this.handleKeydown, null);
  },
  unmounted() {
    clearInterval(this.interval)
    window.removeEventListener('keydown', this.handleKeydown);    
  },
  watch: {
    'imagesModel': function (value) {
      this.loading = true
      if (value.length) {
        this.loading = false
        this.currentSlideImg = 0        
        this.imageNumber = 1
        this.totalSection = value.length
        setTimeout(() => {
          this.$refs.crslModel.slideTo(this.currentImage)
        }, 1)
      }
    },
    'locale': function (val) {
      if (val == 'en')
        this.settings.i18n = {
          iconArrowRight: 'Next Image',
          iconArrowLeft: 'Previous Image'
        }
      else
        this.settings.i18n = {
          iconArrowRight: 'Próxima Imagem',
          iconArrowLeft: 'Imagem Anterior'
        }
    },
    'slidePlay': function (val) {
      if (val == true) {
        this.startPlay()
      } else {
        clearInterval(this.interval)
      }
    },   
    'imageNumber': function(val){
      this.$emit('updateImageView', val)
    },
    'keyDownEvents': function(val){
      if (val) {
        window.addEventListener('keydown', this.handleKeydown, null);
      } else {
        window.removeEventListener('keydown', this.handleKeydown);
      }
    },
  },
  data: () => ({
    // carousel settings
    settings: {
      itemsToShow: 1,
      snapAlign: 'center',
      i18n: {
        iconArrowRight: 'Próxima Imagem',
        iconArrowLeft: 'Imagem Anterior'
      }
    },
    currentSlideImg: 0,
    loading: true,
    imageNumber: 0,
    totalSection: 0,
    prevSession: false,
    interval: null,
    hover: false
  }),
  methods: {
    click(eventChange) {
      //Avançar
      if (this.currentSlideImg === (this.imagesModel.length - 1) && eventChange.target.closest('button.carousel__next') != null ) {
        if (!this.isActiveUser) {
          this.$emit('showModalSubscribePlans', true)
          this.$emit('updateSlidePlay', false)
          window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'paywall',
              paywall: {
                acionador:
                  'Ao finalizar seção gratis e avançar para uma seção de fotos bloqueada'
              }
            })
          event('paywall2', { paywall: { acionador:  'Ao finalizar seção gratis e avançar para uma seção de fotos bloqueada'} })
        } else {
          this.$emit('changeAutomatic', true)
        }
      }
      //Voltar
      if ( this.currentSlideImg === 0 && eventChange.target.closest('button.carousel__prev') != null ) {
        if (!this.isActiveUser) {
          this.$emit('showModalSubscribePlans', true)
          this.$emit('updateSlidePlay', false)  
          window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'paywall',
              paywall: {
                acionador:
                  'Ao finalizar seção gratis e avançar para uma seção de fotos bloqueada'
              }
            })        
          event('paywall2', { paywall: { acionador:  'Ao finalizar seção gratis e avançar para uma seção de fotos bloqueada'} })
        } else {
          this.$emit('changeAutomatic', false) 
        }
      }
    },
    moveSlide(data) {
      this.imageNumber = data.currentSlideIndex+1      
      this.$emit('updateCurrentImage', data.currentSlideIndex)      
      if ( (data.currentSlideIndex+1) == data.slidesCount && !this.isActiveUser) {
        this.$emit('showModalSubscribePlans', true)
        window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'paywall',
              paywall: {
                acionador:
                  'Ao finalizar seção gratis e avançar para uma seção de fotos bloqueada'
              }
            })        
        event('paywall2', { paywall: { acionador:  'Ao finalizar seção gratis e avançar para uma seção de fotos bloqueada'} })
      }
      if (data.currentSlideIndex === 0 && !this.isActiveUser && this.prevSession) {
        this.$emit('showModalSubscribePlans', true)
        window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'paywall',
              paywall: {
                acionador:
                  'Ao finalizar seção gratis e avançar para uma seção de fotos bloqueada'
              }
            })     
        event('paywall2', { paywall: { acionador:  'Ao finalizar seção gratis e avançar para uma seção de fotos bloqueada'} })
      }
    },
    startPlay() {
      clearInterval(this.interval)
      this.$emit('updateSlidePlay', true)
      this.interval = setInterval(function () {
        if (document.getElementsByClassName('carousel__next').length) {
          document.getElementsByClassName('carousel__next')[0].click()
        }
      }, this.seconds*1000)
    },
    stopPlay() {
      this.$emit('updateSlidePlay', false)
    },
    async minusPlay() {
      if (this.seconds > 1) {
        await this.$emit('updateSeconds', this.seconds - 1)
        this.startPlay()
      }
    },
    async plusPlay() {
      if (this.seconds < 10) {
        await this.$emit('updateSeconds', this.seconds + 1)
        this.startPlay()
      }
    },
    startStopPlay() {
      if (this.slidePlay) {
        this.stopPlay()
      } else {
        this.startPlay()        
      }
    },
    handleKeydown (e) {
      if (e.keyCode == 37) { //Arrow Left
        if (document.getElementsByClassName('carousel__prev').length) {
          document.getElementsByClassName('carousel__prev')[0].click()
        }
      } else if (e.keyCode == 39) { //Arrow Right
        if (document.getElementsByClassName('carousel__next').length) {
          document.getElementsByClassName('carousel__next')[0].click()
        }
      } else if (e.keyCode == 38) { //Arrow Up
        e.preventDefault()
        this.plusPlay()
        this.hover = true
        setTimeout(() => {
          this.hover = false
        }, 2000)
      } else if (e.keyCode == 40) { //Arrow Down
        e.preventDefault()
        this.minusPlay()
        this.hover = true
        setTimeout(() => {
          this.hover = false
        }, 2000)
      } else if (e.keyCode == 13 || e.keyCode == 32) { //Enter or Space
        e.preventDefault()
        this.startStopPlay()
        this.hover = true
        setTimeout(() => {
          this.hover = false
        }, 2000)
      }
    }    
  }  
})
</script>
<style scoped>
.button--more svg {
  color: #b20000;
}

.button--more {
  font-family: 'Exo-2';
  font-weight: bold;
  color: #898989;
  font-size: 16px;
}

.small svg {
  margin-right: 5px;
}

.card img {
  width: 100%;
  object-fit: cover;
  height: auto;
}

.card {
  background-color: #fff;
}

.spin-load {
  width: 100%;
  min-height: 31rem;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;
  color: #b20000;
}

.x-of-y {
  font-size: 18px;
}

.slide-controls {
  width: 270px;
  border: 1px solid #000;
  border-radius: 30px;
}

.color-icon {
  color: #5b5858;
  font-size: 16px;
}

.size-seconds {
  font-size: 14px;
  color: white;
  background-color: #5b5858;
  border-radius: 50%;
  width: 27px;
  height: 27px;
  padding: 3px 6px;
}

.title {
  font-family: 'Roboto-Regular';
  font-size: 16px;
}

.row-controls {
  margin-bottom: 20px;

}

/* regras mobile 992px */
@media screen and (max-width: 992px) {
  .x-of-y {
    position: absolute;
    left: -15px;
    top: 12px;
  }
  .col-mobile {
    display: none;
  }

  .slide-controls {
    position: absolute;
    z-index: 1;
    margin-top: 175px;
  }

  .row-controls {
    margin-top: unset;
    margin-bottom: unset;
  }
}
</style>
